<template>
  <!-- 藏品档案-藏品管理 -->
  <el-scrollbar class="w-100">
    <div class="page-public-list">
      <!-- 表头搜索 -->
      <div class="com-list-header">
        <el-form class="com-search-box" :inline="true" :model="form" ref="form">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item class="w-100" label="藏品名称：" prop="key">
                <el-input
                  style="width: 300px"
                  v-model="form.key"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="com-head-search-btns" style="bottom: 30px; top: auto">
          <el-button type="primary" @click="getTableList">查询</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </div>
      </div>
      <div class="com-list-content" style="margin-top: 12px">
        <div class="button">
          <el-row>
            <el-button class="el-primary-border" round @click="addCollect">
              <svg-icon icon-class="add" />&nbsp;新增藏品
            </el-button>
          </el-row>
        </div>
        <!-- 表格 -->
        <div class="table mt-20">
          <el-table
            ref="tableRef"
            @sort-change="sortChange"
            stripe
            v-loading="listLoading"
            :data="tableData"
            :cell-class-name="
              (item) => {
                if (item.columnIndex == 1) return 'g-column-light-box'
              }
            "
            :row-key="
              (row) => {
                return row.collectId
              }
            "
          >
            <el-table-column
              v-for="(item, key) in titleData"
              :sortable="
                item.tableName == 'signCode' ||
                item.tableName == 'typeCode' ||
                item.tableName == 'collectLevel'
              "
              :key="key"
              :prop="item.tableName"
              :label="item.columnName"
              :min-width="
                item.tableName == 'collectYear' ||
                item.tableName == 'collectName'
                  ? '20%'
                  : '10%'
              "
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <viewer
                  :options="{ url: 'data-maxUrl' }"
                  v-if="scope.column.property === 'thumbPicture'"
                >
                  <img
                    class="g-pointer"
                    :src="
                      (scope.row.collectImages &&
                        scope.row.collectImages[0].attPath) ||
                      ''
                    "
                    :data-maxUrl="
                      scope.row.collectImages &&
                      scope.row.collectImages[0].attPath
                    "
                    alt
                    :onerror="defaultImg"
                    style="width: 36px"
                  />
                </viewer>

                <a
                  class="m-btn"
                  type="text"
                  style="margin-left: 0"
                  @click="showDetail(scope.row.collectId)"
                  v-else-if="scope.column.property === 'collectName'"
                  >{{ scope.row.collectName }}</a
                >

                <span v-else-if="scope.column.property === 'attachmentId'">
                  <i
                    class="el-icon-check"
                    v-if="scope.row[scope.column.property]"
                  ></i>
                  <i class="el-icon-minus" v-else></i>
                </span>

                <span
                  v-else-if="scope.column.property === 'threeDimensionalInfo'"
                >
                  <i
                    class="el-icon-check"
                    v-if="scope.row[scope.column.property]"
                  ></i>
                  <i class="el-icon-minus" v-else></i>
                </span>
                <span v-else-if="scope.column.property === 'operation'">
                  <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
                  <a
                    class="m-btn mr-10 m-danger"
                    @click="handleDelete(scope.row)"
                    >删除</a
                  >
                </span>
                <span v-else>{{ scope.row[scope.column.property] }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container paging">
            <el-pagination
              :current-page="listQuery.currentPage"
              :page-size="listQuery.size"
              :total="total"
              background
              layout="total, prev, pager, next, sizes, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>

      <dialog-name-detail ref="dialogNameDetail"></dialog-name-detail>

      <add-collect ref="addCollect" @refresh="getTableList"></add-collect>
    </div>
  </el-scrollbar>
</template>

<script>
import dialogNameDetail from '@views/collect2/record/dialog-name-detail'
import addCollect from '../dialog-add-collect'

export default {
  components: { dialogNameDetail, addCollect },
  data() {
    return {
      order: '1',
      form: {
        key: ''
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [], // 表格数据
      titleData: [
        {
          columnName: '藏品图片',
          tableName: 'thumbPicture'
        },
        {
          columnName: '藏品名称',
          tableName: 'collectName'
        },
        {
          columnName: '类别',
          tableName: 'collectType'
        },
        {
          columnName: '年代',
          tableName: 'collectYear'
        },
        {
          columnName: '级别',
          tableName: 'collectLevel'
        },
        {
          columnName: '三维模型',
          tableName: 'threeDimensionalInfo'
        },
        {
          columnName: '操作',
          tableName: 'operation'
        }
      ],
      listLoading: true,
      defaultImg: this.$store.state.app.defaultImg
    }
  },

  created() {
    this.initList()
  },
  methods: {
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 重置查询
    resetForm() {
      this.$refs.form.resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    sortChange(column) {
      let order = ''
      if (column.prop == 'signCode') {
        if (column.order == 'ascending') {
          order = '1'
        } else if (column.order == 'descending') {
          order = '2'
        } else {
          order = ''
        }
      } else if (column.prop == 'typeCode') {
        if (column.order == 'ascending') {
          order = '3'
        } else if (column.order == 'descending') {
          order = '4'
        } else {
          order = ''
        }
      } else if (column.prop == 'collectLevel') {
        if (column.order == 'ascending') {
          order = '5'
        } else if (column.order == 'descending') {
          order = '6'
        } else {
          order = ''
        }
      }
      this.order = order
      this.listQuery.currentPage = 1
      this.initList()
    },
    // 初始化表格
    initList() {
      this.listLoading = true
      this.$http
        .get('/encollection/list', {
          ...this.listQuery,
          order: this.order,
          ...this.form,
          type: 2
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    addCollect() {
      this.$refs['addCollect'].init('add', '', 2)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 藏品名称
    showDetail(collectId) {
      this.$refs['addCollect'].init('detail', collectId, 2)
    },

    handleEdit(obj) {
      this.$refs['addCollect'].init('edit', obj.collectId, 2)
    },
    handleDelete(obj) {
      console.log(obj)
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .get('/encollection/delete', { id: obj.collectId })
            .then((res) => {
              if (res.success) {
                this.$message.success('删除成功')
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.page-public-list {
  height: 100%;
  width: 100%;
  .table {
    .eye-box {
      position: relative;
      display: inline-block;
      width: 100%;
      padding-right: 20px;
      .eye {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 5px;
      }
    }
  }
}
</style>
